import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { HTMLMotionProps, motion } from 'framer-motion';
import React from 'react';
import { theme } from '../../theme/theme';

const useHighlightCardClasses = makeStyles({
    root: {
        display: 'flex',
        borderRadius: 5,
        borderTop: `5px solid ${theme.colors.darkBlue[5]}`,
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        background: theme.colors.white,
    },
});

/**
 * Highlight card global component.
 * Card with a small blue highlight on the top border.
 */
export const HighlightCard = (props: HTMLMotionProps<'div'>) => {
    const classes = useHighlightCardClasses();

    return <motion.div {...props} className={clsx(classes.root, props.className)} />;
};
